import { t } from "../../../../../utils/i18n";
export type CardStatus =
  | "completed"
  | "active"
  | "processing"
  | "pending"
  | "error"
  | "failed"
  | "rejected"
  | string;

export interface CardRequestData {
  id: string;
  user_id: string;
  name_on_card: string;
  status: CardStatus;
  card_type: string;
}

export interface StatusIconConfig {
  icon: string;
  color: string;
}

// Status configuration mapping
const STATUS_CONFIG: Record<string, StatusIconConfig> = {
  success: {
    icon: "fa-check-circle",
    color: "var(--success-color, #00b894)",
  },
  processing: {
    icon: "fa-spinner fa-spin",
    color: "var(--accent-color, #6c5ce7)",
  },
  error: {
    icon: "fa-times-circle",
    color: "var(--danger-color, #e17055)",
  },
  default: {
    icon: "fa-info-circle",
    color: "var(--text-light, #636e72)",
  },
};

// Status categories
const STATUS_CATEGORIES = {
  success: ["completed", "active"],
  processing: ["processing", "pending"],
  error: ["error", "failed", "rejected"],
};

/**
 * Get status icon configuration based on status
 */
export const getStatusIconConfig = (status: string): StatusIconConfig => {
  const normalizedStatus = status.toLowerCase();

  // Check success statuses
  if (STATUS_CATEGORIES.success.includes(normalizedStatus)) {
    return STATUS_CONFIG.success;
  }

  // Check processing statuses
  if (STATUS_CATEGORIES.processing.includes(normalizedStatus)) {
    return STATUS_CONFIG.processing;
  }

  // Check error statuses
  if (STATUS_CATEGORIES.error.includes(normalizedStatus)) {
    return STATUS_CONFIG.error;
  }

  return STATUS_CONFIG.default;
};

/**
 * Format card type for display
 */
export const formatCardType = (cardType: string): string => {
  if (!cardType) return t("cards.details.card_fallback");
  return cardType.replace(/_/g, " ").toUpperCase();
};

/**
 * Get fallback card image URL
 */
export const getFallbackCardImage = (): string => {
  return "https://via.placeholder.com/400x250?text=Card+Image";
};

/**
 * Format status for display
 */
export const formatStatus = (status: string): string => {
  return (status || t("cards.common.not_available")).toUpperCase();
};
